import { createAction, union } from '@ngrx/store';

export const loadStart = createAction('[Loader] Start loader progress', (id: string) => ({ id }));

export const loadStop = createAction('[Loader] Stop loader progress', (id: string) => ({ id }));

export const loadError = createAction('[Loader] Error', (id: string, message: string) => ({
  id,
  message,
}));

const all = union({
  loadStart,
  loadStop,
  loadError,
});
export type Actions = typeof all;
